import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { useDispatch, useSelector } from 'react-redux';
import {
  chooseAudioInputDeviceAction,
  chooseAudioOutputDeviceAction,
  chooseVideoInputDeviceAction,
  chooseUpstreamVideoQualityAction,
} from 'store/chime/chimeActions';
import upstreamVideoQualities from 'constants/upstreamVideoQualities';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.light,
    margin: theme.sidePanel.gutter,
    padding: '1rem',
    ...theme.mixins.borderRadius(),
    ...theme.mixins.shadow(),
    '& > *': {
      width: '100%',
      marginBottom: '2rem',
      '& .MuiSelect-selectMenu': {
        fontSize: '90%',
      },
    },
  },
}));

DeviceSwitcher.propTypes = {
  qualityPanel: PropTypes.bool,
};

export default function DeviceSwitcher({ qualityPanel }) {
  const dispatch = useDispatch();
  const {
    currentAudioInputDevice,
    currentAudioOutputDevice,
    currentVideoInputDevice,
    audioInputDevices,
    audioOutputDevices,
    videoInputDevices,
    upstreamVideoQuality,
  } = useSelector(({ chime }) => ({
    currentAudioInputDevice: chime.currentAudioInputDevice,
    currentAudioOutputDevice: chime.currentAudioOutputDevice,
    currentVideoInputDevice: chime.currentVideoInputDevice,
    audioInputDevices: chime.audioInputDevices,
    audioOutputDevices: chime.audioOutputDevices,
    videoInputDevices: chime.videoInputDevices,
    upstreamVideoQuality: chime.upstreamVideoQuality,
  }));
  const classes = useStyles();

  const changeAudioInput = (event) => {
    dispatch(chooseAudioInputDeviceAction({ device: { value: event.target.value } }));
  };
  const changeAudioOutput = (event) => {
    dispatch(chooseAudioOutputDeviceAction({ device: { value: event.target.value } }));
  };
  const changeVideoInput = (event) => {
    dispatch(chooseVideoInputDeviceAction({ device: { value: event.target.value } }));
  };
  const changeUpstreamVideoQuality = (event) => {
    dispatch(chooseUpstreamVideoQualityAction({ id: event.target.value }));
  };

  return (
    <div className={classes.root}>
      <FormControl>
        <InputLabel id="audio-input-label">Audio Input Device</InputLabel>
        <Select
          labelId="audio-input-label"
          id="audio-input-select"
          value={currentAudioInputDevice || ' '}
          onChange={changeAudioInput}
        >
          {audioInputDevices.map((aid) => {
            return (
              <MenuItem key={aid.value} value={aid.value}>
                {aid.label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      <FormControl>
        <InputLabel id="audio-output-label">Audio Output Device</InputLabel>
        <Select
          labelId="audio-output-label"
          id="audio-output-select"
          value={currentAudioOutputDevice || ' '}
          onChange={changeAudioOutput}
        >
          {audioOutputDevices.map((aod) => {
            return (
              <MenuItem key={aod.value} value={aod.value}>
                {aod.label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      <FormControl>
        <InputLabel id="video-input-label">Video Input Device</InputLabel>
        <Select
          labelId="video-input-label"
          id="video-input-select"
          value={currentVideoInputDevice || ' '}
          onChange={changeVideoInput}
        >
          {videoInputDevices.map((vid) => {
            return (
              <MenuItem key={vid.value} value={vid.value}>
                {vid.label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      {qualityPanel && (
        <FormControl>
          <InputLabel id="video-input-label">Upstream Quality</InputLabel>
          <Select
            labelId="video-input-label"
            id="video-input-select"
            value={upstreamVideoQuality}
            onChange={changeUpstreamVideoQuality}
          >
            {/*<MenuItem key={-1} value={-1}>
            Auto
          </MenuItem>*/}
            {upstreamVideoQualities.map((quality, index) => {
              return (
                <MenuItem key={index} value={index}>
                  {quality.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </div>
  );
}
